// angular
// 	.module("HeroPRO")
// 	.controller("TrainingBtnController", trainingTopicController);

import './trainingBtn.scss';

/* @ngInject */
export default function trainingTopicController($scope, $document) {
    const vm = this;
    let valid = false;

    vm.showNoSelection = false;
    vm.showWrongSelection = false;

    vm.next = function () {
        valid = validate($scope.validate, $scope.current);

        if (valid) {
            $scope.advance();
        }
    };

    vm.prev = function () {
        getRadioButtons($scope.parentClass, $document[0]).removeClass('no-selection');
        vm.showNoSelection = false;
        vm.showWrongSelection = false;
        $scope.retreat();
    };

    $scope.$on('answerSelected', (e, data) => {
        vm.showNoSelection = false;
        if ($scope.current && $scope.current.SelectedAnswer !== data.selection) {
            vm.showWrongSelection = false;
        }
    });


    function validate(isValidated, topic) {
        let isValid = false;
        if (!isValidated || !topic) {
            return true;
        }
        if (topic.SelectedAnswer === topic.CorrectAnswer) {
            isValid = true;
        } else if (!topic.SelectedAnswer) {
            getRadioButtons($scope.parentClass, $document[0]).addClass('no-selection');
            vm.showNoSelection = true;
        } else if (topic.SelectedAnswer !== topic.CorrectAnswer) {
            vm.showWrongSelection = true;
        }


        return isValid;
    }

    function getRadioButtons(container, document) {
        return angular.element(document.querySelectorAll(`.${container} .icon-radio-default`));
    }
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/training/directives/trainingBtn/trainingBtnController.js